<template>
    <div class="archivesInfo" v-if="info">
        <div class="content">
            <h4>入学档案</h4>
            <ul>
                <li>
                    <div>
                        <h5>姓名</h5>
                        <p>{{info.realName}}</p>
                    </div>
                    <div>
                        <h5>当前就读（毕业）的院校和专业</h5>
                        <div class="schoolSubject">
                            <span>{{info.ugCollege || '--'}}</span>
                            <span>{{info.ugSubject || '--'}}</span>
                        </div>
                    </div>
                </li>
                <li v-if="info.beTgSchool || info.beTgSubject">
                    <div v-if="info.beTgSchool">
                        <h5>考研目标院校</h5>
                        <p>{{info.beTgSchool}}</p>
                    </div>
                    <div v-if="info.beTgSubject">
                        <h5>考研目标专业</h5>
                        <p>{{info.beTgSubject}}</p>
                    </div>
                </li>
                <li>
                    <div v-if="beCrossInfo">
                        <h5>跨考情况</h5>
                        <p>{{beCrossInfo}}</p>
                    </div>
                    <div>
                        <h5>学生性质</h5>
                        <p>{{learnType}}</p>
                    </div>
                    <div>
                        <h5>是否二战</h5>
                        <p>{{beAgain}}</p>
                    </div>
                </li>
                 <li v-if="info.beCet4Score || info.beCet6Score">
                    <div v-if="info.beCet4Score">
                        <h5>四级分数</h5>
                        <p>{{info.beCet4Score}}</p>
                    </div>
                    <div v-if="info.beCet6Score">
                        <h5>六级分数</h5>
                        <p>{{info.beCet6Score}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      beCrossArr: [
        {
          id: 0,
          title: '跨校跨专业',
        },
        {
          id: 1,
          title: '跨校不跨专业',
        },
        {
          id: 2,
          title: '不跨校跨专业',
        },
        {
          id: 3,
          title: '本校本专业',
        },
        {
          id: 4,
          title: '我还没想好',
        },
      ],
      learnTypeArr: [
        {
          id: 3,
          title: '大二',
        },
        {
          id: 4,
          title: '大三',
        },
        {
          id: 5,
          title: '大四',
        },
        {
          id: 1,
          title: '在职',
        },
        {
          id: 2,
          title: '脱产',
        },
        {
          id: 6,
          title: '专升本',
        },
      ],
      beAgainArr: [
        {
          id: 1,
          title: '是',
        },
        {
          id: 0,
          title: '否',
        },
      ],
    };
  },
  computed: {
    beCrossInfo() {
      const arr = this.beCrossArr.filter((item) => item.id === this.info.beCrossInfo);
      if (arr.length) {
        return arr[0].title;
      }
      return '';
    },
    learnType() {
      const arr = this.learnTypeArr.filter((item) => item.id === this.info.learnType);
      if (arr.length) {
        return arr[0].title;
      }
      return '';
    },
    beAgain() {
      const arr = this.beAgainArr.filter((item) => item.id === this.info.beAgain);
      if (arr.length) {
        return arr[0].title;
      }
      return '';
    },
  },
  props: {
    info: {
      require: true,
      type: Object,
    },
  },
};
</script>
<style lang="scss" scoped>
.archivesInfo {
    width: 100%;
    padding: 36px;
    text-align: left;
    .content {
        padding: 0 36px 36px;
        font-size: 25px;
        background: url('../../../assets/img/arkHome/archivesTitle.png') no-repeat top center;
        background-size: 100% 87px;
        border: 2px solid #FFDCC3;
        border-radius: 18px;
        h4 {
            width: 100%;
            height: 87px;
            font-size: 33px;
            line-height: 87px;
            text-align: center;
        }
        ul {
            li {
                padding-bottom: 50px;
                border-bottom: 2px solid #F8F8F8;
                div {
                    h5 {
                        position: relative;
                        width: 100%;
                        height: 40px;
                        margin: 50px 0 20px;
                        padding-left: 20px;
                        font-size: 29px;
                        line-height: 40px;
                    }
                    h5::before {
                        position: absolute;
                        top: 50%;
                        left: 0;
                        width: 11px;
                        height: 25px;
                        font-size: 29px;
                        background: #FF7F41;
                        border-radius: 5px;
                        transform: translateY(-50%);
                        content: '';
                    }
                    .schoolSubject {
                        position: relative;
                        display: flex;
                        width: 100%;
                        height: 127px;
                        background: #F8F8F8;
                        border-radius: 18px;
                        span {
                            display: flex;
                            flex: 50%;
                            align-items: center;
                            justify-content: center;
                            padding: 0 40px;
                            line-height: 30px;
                        }
                    }
                    .schoolSubject::after {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 2px;
                        height: 36px;
                        background: #333;
                        transform: translate(-50%,-50%);
                        content: '';
                    }
                }
            }
        }

    }
}
</style>
